export default __webpack_public_path__ + "static/media/menu_m_04.fb0a04a4.jpg";